var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
/**
 * A mailed wallet-passphrase link (/account/reset-passphrase/<token> from the apps and the
 * account page, /wallet/reset-passphrase/<token> from the web wallet) opened without a session:
 * the guard keeps the link, the home page hands it to the login window and the login returns to
 * it instead of leaving the user on the home page (planning #2740). Every other guarded page
 * keeps landing on the home page.
 */
const RESET_PASSPHRASE_LINK = /^\/(account|wallet)\/reset-passphrase\/[^\/?#]+/;
export const LOGIN_REDIRECT_KEY = 'login_redirect';
export function isResetPassphraseLink(url) {
    return typeof url === 'string' && RESET_PASSPHRASE_LINK.test(url);
}
/** Keeps the link for the login window; false when the URL is not a reset link or storage is unavailable. */
export function rememberLoginRedirect(url, storage = sessionStorage) {
    if (!isResetPassphraseLink(url)) {
        return false;
    }
    try {
        storage.setItem(LOGIN_REDIRECT_KEY, url);
        return true;
    }
    catch (e) {
        return false;
    }
}
/** The kept link, once: it is removed on read so a later login does not return to a stale link. */
export function takeLoginRedirect(storage = sessionStorage) {
    try {
        const url = storage.getItem(LOGIN_REDIRECT_KEY);
        if (url !== null) {
            storage.removeItem(LOGIN_REDIRECT_KEY);
        }
        return isResetPassphraseLink(url) ? url : null;
    }
    catch (e) {
        return null;
    }
}
